import { Outlet, Link } from 'react-router-dom';
import { useRef, useEffect } from 'react';
import gsap from 'gsap';
import AuthSlider from '../auth/AuthSlider';
import LogoIcon from '../../assets/logo.svg';

export default function AuthLayout() {
  const panelRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(panelRef.current, { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: 0.4, ease: 'power2.out' });
  }, []);

  return (
    <div className="min-h-screen flex bg-background">
      <AuthSlider />

      <div className="flex-1 flex flex-col items-center px-4 sm:px-8 py-8 sm:py-12 overflow-y-auto">
        <Link to="/" className="flex items-center gap-2 mb-8 lg:hidden">
          <img src={LogoIcon} alt="" className="h-8 w-8" />
          <span className="font-semibold text-foreground">Cavan Capital</span>
        </Link>

        <div ref={panelRef} className="w-full max-w-md m-auto">
          <div className="glass-card p-6 sm:p-10">
            <Outlet />
          </div>
          <p className="text-center text-xs text-foreground-subtle mt-6">
            <Link to="/" className="hover:text-foreground-muted transition-colors">
              ← Back to homepage
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
